import React from 'react';

// @material-ui/core components

// core components
import GridContainer from '@components/Grid/GridContainer.js';
import GridItem from '@components/Grid/GridItem.js';

import { Formik, FormikProps } from 'formik';
import { loginUserValidationSchema } from 'apps/things/app/validations';
import CardWrapper from '@components/Card/CardWrapper';
import ItemForm from './ItemForm';
import { AdminRegisterDistributorInput } from 'apps/clientService/app/types/clientServiceGlobalTypes';

interface IRTable {
  title?: string;
  TableAction?: React.ReactNode;
  bulkDeleteProducts?: () => void;
  handleSubmit: (payload: AdminRegisterDistributorInput) => void;
  isLoading: boolean;
  item: AdminRegisterDistributorInput;
}

const AddItem: React.FC<IRTable> = ({ handleSubmit, isLoading, item }) => {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CardWrapper>
          {item && (
            <Formik
              onSubmit={async (values: any) => handleSubmit(values)}
              initialValues={item}
              validationSchema={loginUserValidationSchema}
              validateOnChange={true}
            >
              {(formBag) => (
                <ItemForm
                  formBag={
                    (formBag as unknown) as FormikProps<
                      AdminRegisterDistributorInput
                    >
                  }
                  disableLoginButton={isLoading}
                />
              )}
            </Formik>
          )}
        </CardWrapper>
      </GridItem>
    </GridContainer>
  );
};

export default AddItem;
